import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage   from './LandingPage';
import RatingPage    from './RatingPage';
import BonusPage     from './BonusPage';
import RecruitSignup from './RecruitSignup';
import AdminPanel    from './AdminPanel';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"                                element={<LandingPage />} />
        <Route path="/rate/:affiliateId/:linkId"       element={<RatingPage />} />
        <Route path="/bonus/:affiliateId/:linkId"      element={<BonusPage />} />
        <Route path="/recruit/:recruiterId"            element={<RecruitSignup />} />
        <Route path="/admin"                           element={<AdminPanel />} />
        <Route path="*" element={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', textAlign: 'center', backgroundColor: '#F8F8F6' }}>
            <div>
              <h1 style={{ color: '#3F3F3C' }}>Page Not Found</h1>
              <a href="/" style={{ display: 'inline-block', padding: '12px 24px', border: '2px solid #C15F3C', borderRadius: 200, color: '#C15F3C', textDecoration: 'none', fontSize: 16, fontWeight: 600 }}>Go to Homepage</a>
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;